export const FULFILLMENT_METHOD_DELIVERY = 'DELIVERY';
export const FULFILLMENT_METHOD_COLLECTION = 'COLLECTION';
export const FULFILLMENT_METHOD_DEFAULT = FULFILLMENT_METHOD_DELIVERY;
export const FULFILLMENT_METHODS = [FULFILLMENT_METHOD_DELIVERY, FULFILLMENT_METHOD_COLLECTION];

export const FULFILLMENT_DAY_TODAY = 'TODAY';
export const FULFILLMENT_DAY_DEFAULT = FULFILLMENT_DAY_TODAY;

export const FULFILLMENT_TIME_ASAP = 'ASAP';
export const FULFILLMENT_TIME_DEFAULT = FULFILLMENT_TIME_ASAP;

export const HOMEPAGE_REFERRER = 'homepage';
export const HOME_FEED_REFERRER = 'home feed';
